module.exports = __webpack_public_path__ + "img/lightspeed.abf87296.png";